import { render, staticRenderFns } from "./btnWithIcon.vue?vue&type=template&id=126a51cc&"
import script from "./btnWithIcon.vue?vue&type=script&lang=js&"
export * from "./btnWithIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports